import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import config from 'constants/config'

type SoftDeleteItemsRequest = paths['/api/carts/multi-carts/{multiCartId}/soft-delete-items']['post']['parameters']['body']['payload']
type SoftDeleteItemsResponse = paths['/api/carts/multi-carts/{multiCartId}/soft-delete-items']['post']['responses']['204']['content']['application/json']

export async function softDeleteItemsFromMultiCart(
  multiCartId: string,
  itemIds: Array<string>,
): Promise<{ success: boolean }> {
  if (itemIds.length === 0) {
    return Promise.resolve({ success: true })
  }

  const payload: SoftDeleteItemsRequest = {
    itemIds,
  }

  await request.post<SoftDeleteItemsResponse, SoftDeleteItemsRequest>(
    `/api/carts/multi-carts/${multiCartId}/soft-delete-items?brand=${config.BRAND}`,
    payload,
    { credentials: 'include' },
  )

  return { success: true }
}
